export const findLastIndex = (array, predicate) => {
  let l = array.length;
  while (l--) {
    if (predicate(array[l], l, array)) return l;
  }
  return -1;
};

export const getUnique = (arr, propName) => {
  let mapObj = new Map();
  arr.forEach((v) => {
    let prevValue = mapObj.get(v[propName]);
    if (!prevValue || prevValue.type === "new") {
      mapObj.set(v[propName], v);
    }
  });
  return [...mapObj.values()];
};

export const unique = (arr) => {
  function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  return arr.filter(onlyUnique);
};

export const findRow = (arr, rowIndex, colCount) => {
  for (let i = 0; i < colCount; i++) {
    const cell = arr.findIndex((c) => c.x === rowIndex && c.y === i);
    if (cell === -1) {
      return false;
    }
  }
  return true;
};

export const findCol = (arr, colIndex, rowCount) => {
  for (let i = 0; i < rowCount; i++) {
    const cell = arr.findIndex((c) => c.y === colIndex && c.x === i);
    if (cell === -1) {
      return false;
    }
  }
  return true;
};
